import { Component, OnInit } from '@angular/core';

import { LongProgressService, ACTIVE_TASK_USER_CONFIG_KEY } from '../../_services/long-progress.service'
import { UserService } from '../../_services/user.service'
import { AuthContextService } from '../../_services/auth.service';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../_services/notification.service';

@Component({
  selector: 'app-long-progress',
  templateUrl: './long-progress.component.html',
  styleUrls: ['./long-progress.component.scss']
})
export class LongProgressComponent implements OnInit {
  
  endProgressEventSubscription: Subscription;
  tabStatusEventSubscription: Subscription;
  progessList = [];
  notificationsOpened = false;

  constructor(private longProgressService: LongProgressService,
              private userService: UserService,
              private authContextService: AuthContextService,
              private notificationService: NotificationService
  ) { 
    
  }

  ngOnInit() {

    this.notificationSubscription();

    this.progressEndEvent();

    this.progressTabCheck()

    let updatedActivetasks = {};

    var now = new Date(); // today!
    var nowUtc = new Date( now.getTime() + (now.getTimezoneOffset() * 60000));

    var noOfDays = 1; // go back 1 days!
    nowUtc.setDate(nowUtc.getDate() - noOfDays);


    if(this.authContextService.isLoggedIn()) {
      let activetasks = this.userService.getConfig(ACTIVE_TASK_USER_CONFIG_KEY)
      
      for(var key in activetasks) {
        
        if (("created_at" in activetasks[key]) && (new Date(activetasks[key]["created_at"]) >= nowUtc))
        {
          this.longProgressService.resumeProgress(activetasks[key])
          updatedActivetasks[activetasks[key]["activeProjectID"]] = activetasks[key]
        }else{
        }     
      }
      
      this.userService.setConfig(ACTIVE_TASK_USER_CONFIG_KEY, updatedActivetasks)
    }
    
  }

  ngOnDestroy() {
    this.endProgressEventSubscription.unsubscribe();
    this.tabStatusEventSubscription.unsubscribe();
  }

  notificationSubscription() {
    this.longProgressService.showProgressEvent.subscribe((statusData) => {
      statusData.show = true;
      statusData.waiting = false;
      this.progessList.unshift(statusData)
      this.progessList = this.progessList.filter((value, index, self) => index === self.findIndex((t) => (t.taskId === value.taskId)))
      if(this.notificationsOpened) {
        statusData.show = false;
      }
      setTimeout(() => {
        const index = this.progessList.indexOf(statusData)
        if (index !== -1) {
          if(this.progessList[index].icon !== 'download') {
            if(this.progessList[index].waiting) {
              setTimeout(() => {
                this.progessList[index].show = false;
                this.progessList[index].waiting = false;
              }, 20000);
            } else {
              this.progessList[index].show = false;
            }
          }
        }
      }, 10000)
    })
  }

  progressEndEvent() {
    this.endProgressEventSubscription = this.notificationService.endProgressEvent.subscribe(data => {
      this.progessList.forEach((item) => {
        if(item.taskId === data.progress.taskId) {
          item.waiting = true;
          if(!this.notificationsOpened) {
            item.show = true;
            if(!item.isActive) {
              item.isActive = true;
            }
          } else {
            item.show = false;
            if(!item.isActive) {
              item.isActive = false;
            }
          }
          if(item.icon === 'download' && !this.notificationsOpened) {
            item.show = true;
          } else {
            setTimeout(() => {
              item.show = false;
              item.waiting = false;
            }, 20000);
          }
        }
      })
    })
  }

  progressTabCheck() {
    this.tabStatusEventSubscription = this.longProgressService.currentNotificationTab.subscribe(content => {
      if(content.currentTab == "progress-bar") {
        this.notificationsOpened = true;
        this.progessList.forEach((item) => {
          if(item.show) {
            item.show = false;
          }
        })
      } else {
        this.notificationsOpened = false;
      }
    })
  }

}
